import type { APIClient } from '@src/shared/api';
import { formatIsoDate } from '@src/shared/lib';
import { prefetchQuery } from '@src/shared/query';
import { groupStatsUrl } from './constants';

export default function prefetchGroupStats(
  client: APIClient,
  userId: number,
  availableUntil?: Date,
) {
  const queryParams: Record<string, string> = { user_id: String(userId) };
  if (availableUntil) {
    queryParams.available_until = formatIsoDate(availableUntil);
  }
  return prefetchQuery(groupStatsUrl, client, { queryParams });
}
